import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import BackArrow, { DIRECTIONS, ARROW_SIZES } from 'components/BackArrow';
import { SenaryHeading } from 'components/Headings';
import { largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const LearnMore = ({ text, href, trackEvent, isDisabled }) => {
  const { BUTTON_LENGTH } = ARROW_SIZES.DEFAULT;
  return (
    <a
      className={classNames('LearnMore__content', { 'LearnMore__content--disabled': isDisabled })}
      href={href}
      onClick={trackEvent}
    >
      {isDisabled ? (
        <div className="LearnMore__heading-wrapper">
          <SenaryHeading className="LearnMore__heading">
            {text} ({I18n.localize('sustainabilityPage.comingSoon')})
          </SenaryHeading>
        </div>
      ) : (
        <>
          <SenaryHeading className="LearnMore__heading">{text}</SenaryHeading>
          <BackArrow direction={DIRECTIONS.RIGHT} />
        </>
      )}
      <style jsx>
        {`
          .LearnMore__content {
            display: flex;
            align-items: center;
            text-decoration: none;
            padding: ${Theme.get('spacing') * 2}px 0;
          }

          .LearnMore__content--disabled {
            pointer-events: none;
          }

          .LearnMore__heading-wrapper {
            min-height: ${BUTTON_LENGTH}px;
            display: flex;
            align-items: center;
          }
        `}
      </style>
      <style jsx global>
        {`
          .LearnMore__content .BackArrow {
            transition: all ${Theme.get('transition-duration-ms')}
              ${Theme.get('transition-timing-ease-out')};
          }

          @media ${largeUp} {
            .LearnMore__content:hover .BackArrow {
              transition: all ${Theme.get('transition-duration-ms')}
                ${Theme.get('transition-timing-ease-out')};
              transform: translateX(${Theme.get('spacing') * 2}px);
            }
          }

          .LearnMore__heading.typography--senary-heading {
            flex-grow: 1;
            margin-top: ${Theme.get('spacing') / 2}px;
            margin-right: ${Theme.get('spacing') * 3}px;
          }
        `}
      </style>
    </a>
  );
};

LearnMore.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  trackEvent: PropTypes.func,
  isDisabled: PropTypes.bool,
};

LearnMore.defaultProps = {
  trackEvent: () => {},
  isDisabled: false,
};

export default LearnMore;
